import { LOADING_REPORT, LOADING_TIMESHEET_REPORT, GET_ENDOFDAY_REPORT, GET_TIMESHEETS_REPORT, GET_DETAILED_ORDER_REPORT, RESET_REPORT } from '../actions/index';

let initialState = {
  "loading" : false
};

export default function(state = initialState, action) {
  switch(action.type) {
    case LOADING_REPORT:
      return {
        loading: true,
        items: state.items
      }
    case LOADING_TIMESHEET_REPORT:
      return {
        loading:true,
        items: state.items,
        employees: state.employees
      }
    case GET_ENDOFDAY_REPORT:
      return {
        items: action.payload
      }
    case GET_DETAILED_ORDER_REPORT:
      return {
        items: action.payload.items
      }
    case GET_TIMESHEETS_REPORT:
      return {
        items: action.payload.items,
        employees: state.employees
      }
    case RESET_REPORT:
      return {
        loading: false,
        items: null,
      }    
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_reports.js